module.exports = "/_next/static/images/1759e0c5fc1bdccad5050a7fbee5344c-people-working-together@xs-2x.jpg";